import * as moment from 'moment';

export function getCurrentWeekRange(format = 'YYYY-MM-DD[T]HH:mm:ss'): {
  weekFirstDay: Date | string;
  weekLastDay: Date | string;
} {
  const currentDate = new Date();
  const currentDay = currentDate.getDay();

  const mondayOffset = currentDay === 0 ? -6 : 1 - currentDay;
  const sundayOffset = currentDay === 0 ? 0 : 7 - currentDay;

  const weekFirstDay = new Date(currentDate);
  weekFirstDay.setDate(currentDate.getDate() + mondayOffset);
  weekFirstDay.setHours(0, 0, 0, 0);

  const weekLastDay = new Date(currentDate);
  weekLastDay.setDate(currentDate.getDate() + sundayOffset);
  weekLastDay.setHours(23, 59, 59, 59);

  return {
    weekFirstDay: moment(weekFirstDay).format(format),
    weekLastDay: moment(weekLastDay).format(format),
  };
}

export function setStartDayTimeToDate(
  date: Date | string,
  format = 'YYYY-MM-DD[T]HH:mm:ss'
): string {
  return moment(date).startOf('day').format(format);
}

export function setEndDayTimeToDate(
  date: Date | string,
  format = 'YYYY-MM-DD[T]HH:mm:ss'
): string {
  return moment(date).endOf('day').format(format);
}

/** Cloud timestamps are GMT. A missing zone is GMT, then shown in local time. */
export function formatUtcAsLocal(
  value: string | null | undefined,
  format: string
): string {
  if (!value) {
    return '';
  }

  const utc = moment.utc(value);
  if (!utc.isValid()) {
    return '';
  }

  return utc.local().format(format);
}
